import { Select, Switch, TextInput } from '@mantine/core';
import useLlmModels, { withCurrent } from '../../../helpers/useLlmModels';
import HelpPopover from '../../HelpPopover/HelpPopover';
import SettingRow from '../../SettingRow/SettingRow';
import { HELP, applyExample } from './superAdminHelp';

// Only the vendor providers can bill Releva's own tokens; a registry host always uses its stored key.
const VENDOR_PROVIDERS = ['claude', 'chatGPT'];

const ModelRuntimeSection = ({ chatBot, handleChange }) => {
  const [llmModels] = useLlmModels();
  const groups = llmModels || [];
  const providers = groups.map(({ group, providerKey }) => ({ value: providerKey, label: group }));
  const providerModels = (provider) =>
    groups
      .find(({ providerKey }) => providerKey === provider)
      ?.items.map(({ modelId, label, lastTestOk }) => ({
        value: modelId,
        label: lastTestOk === true ? label : `${label} (${lastTestOk === false ? 'failed' : 'not tested'})`,
        disabled: lastTestOk !== true,
      })) || [];

  // ChatBotPage also renders for merchants, who cannot read the registry, so the reset model rides on the event.
  const changeProvider = (value) =>
    handleChange({
      target: {
        name: 'provider',
        value,
        model: providerModels(value).find(({ disabled }) => !disabled)?.value ?? null,
      },
    });

  return (
    <>
      <SettingRow label="Provider" htmlFor="provider" help={<HelpPopover {...HELP.provider} />}>
        <Select
          id="provider"
          size="xs"
          maw={320}
          data={withCurrent(providers, chatBot.provider)}
          value={chatBot.provider}
          onChange={changeProvider}
          placeholder="Type to search..."
          required
          allowDeselect={false}
        />
      </SettingRow>

      <SettingRow label="Model" htmlFor="model" help={<HelpPopover {...HELP.model} />}>
        <Select
          id="model"
          size="xs"
          maw={320}
          data={withCurrent(providerModels(chatBot.provider), chatBot.model)}
          value={chatBot.model}
          onChange={(value) => handleChange({ target: { name: 'model', value } })}
          placeholder="Type to search..."
          required
          allowDeselect={false}
        />
      </SettingRow>

      <SettingRow
        label="Profile version"
        htmlFor="profileVersion"
        help={
          <HelpPopover
            {...HELP.profileVersion}
            onUse={applyExample(handleChange, 'profileVersion', chatBot.profileVersion ?? '')}
          />
        }
      >
        <TextInput
          id="profileVersion"
          name="profileVersion"
          size="xs"
          w={120}
          value={chatBot.profileVersion || ''}
          placeholder="live pointer"
          onChange={(e) => handleChange({ target: { name: 'profileVersion', value: e.currentTarget.value } })}
        />
      </SettingRow>

      {VENDOR_PROVIDERS.includes(chatBot.provider) && (
        <SettingRow
          label="Use Releva tokens"
          htmlFor="useRelevaTokens"
          help={<HelpPopover {...HELP.useRelevaTokens} />}
        >
          <Switch
            id="useRelevaTokens"
            size="xs"
            checked={chatBot.useRelevaTokens}
            onChange={(e) => handleChange({ target: { name: 'useRelevaTokens', value: e.currentTarget.checked } })}
          />
        </SettingRow>
      )}
    </>
  );
};

export default ModelRuntimeSection;
